import { ISelectOption } from '@/components/YhFormBox/Types'
import { generateUniqueId } from '@/utils/utils'
import { message } from 'antd'
import { SelectValue } from 'antd/lib/select'
import { createModel } from 'hox'
import { useLayoutEffect, useRef, useState } from 'react'
import { inquiryService } from '../../inquiryService'
import { IInquiryDetail, IInquiryGoods, IInquiryGoodsForContrast } from '../../inquiryTypes'
import { IInquiryGoodsResultSave, IInquiryGoodsResultSaveDetail } from '@/views/inquiryResult/inquiryResultTypes'
import { inquiryResultService } from '@/views/inquiryResult/inquiryResultService'

interface IViceChoosedSupplierCodeS {
    one: string | undefined
    two: string | undefined
}

export const useInquiryContrastModel = createModel(function () {
    //主单数据
    const [mavbList, setMavbList] = useState<IInquiryGoodsForContrast[]>([])
    const [mavbChoosedSupplierCode, setMavbChoosedSupplierCode] = useState<string | undefined>(undefined)
    const [mavbChoosedInquiryId, setMavbChoosedInquiryId] = useState<string | undefined>(undefined)

    //副单数据
    const [viceChoosedSupplierCode, setViceChoosedSupplierCode] = useState<IViceChoosedSupplierCodeS>({ one: undefined, two: undefined })

    // const saveRef = useRef<{mainList: IInquiryGoodsForContrast[], one: IInquiryGoodsForContrast[], two: IInquiryGoodsForContrast[]}>({mainList:[],one:[],two:[]})

    const saveRef = useRef<{
        main: {
            list: IInquiryGoodsForContrast[]
            supplierCode?: string
            supplierName?: string
            inquiryCode?: string
        }
        one: {
            list: IInquiryGoodsForContrast[]
            supplierCode?: string
            supplierName?: string
            inquiryCode?: string
        }
        two: {
            list: IInquiryGoodsForContrast[]
            supplierCode?: string
            supplierName?: string
            inquiryCode?: string
        }
    }>({
        main: {
            list: [],
            supplierCode: '',
            supplierName: '',
            inquiryCode: '',
        },
        one: {
            list: [],
            supplierCode: '',
            supplierName: '',
            inquiryCode: '',
        },
        two: {
            list: [],
            supplierCode: '',
            supplierName: '',
            inquiryCode: '',
        },
    })

    useLayoutEffect(() => {
        saveRef.current.main.list = mavbList
    }, [mavbList])

    //查询询价单的列表
    const getInquiryList = async (supplierCode: string) => {
        try {
            let searchData = {
                pageSize: 100000,
                pageNum: 1,
                supplierCode,
            }
            let { retData } = await inquiryService.page(searchData)
            return retData
        } catch (err) {
            message.error(err)
        }
    }
    //查询询价单的商品
    const getGoodsList = async (id: string) => {
        try {
            let { retData } = await inquiryService.one(id)
            return retData
        } catch (err) {
            message.error(err)
        }
    }

    const changeMavbList = (list: IInquiryGoods[]) => {
        let newList: IInquiryGoodsForContrast[] = list
        while (list.length < 15) {
            newList.push({ id: generateUniqueId() })
        }
        setMavbList(newList)
    }

    const handelSave = async () => {
        if (saveRef.current.one.list.length === 0 && saveRef.current.two.list.length === 0) {
            message.error('请选择对比单')
            return
        }
        const {main, one, two} = saveRef.current
        const params: IInquiryGoodsResultSave = {
            supplierCode: "",
            supplierName: "",
            inquiryCode: "",
            sumInquiryDetailsResultList: [],
        }
         const arr = ['main', 'one', 'two']
        let supplierCodeArr:string[] = []
        let supplierNameArr:string[] = []
        let inquiryCodeArr:string[] = []
        let sumInquiryDetailsResultList: IInquiryGoodsResultSaveDetail[] = []
        arr.forEach(item => {
            if(saveRef.current[item as 'main' | 'one' | 'two'].supplierCode){
                supplierCodeArr.push(saveRef.current[item as 'main' | 'one' | 'two'].supplierCode as string)
            }
            if(saveRef.current[item as 'main' | 'one' | 'two'].supplierName){
                supplierNameArr.push(saveRef.current[item as 'main' | 'one' | 'two'].supplierName as string)
            }
            if(saveRef.current[item as 'main' | 'one' | 'two'].inquiryCode){
                inquiryCodeArr.push(saveRef.current[item as 'main' | 'one' | 'two'].inquiryCode as string)
            }
        })
        params.supplierCode = supplierCodeArr.join(',')
        params.supplierName = supplierNameArr.join(',')
        params.inquiryCode = inquiryCodeArr.join(',')

        let mainList = saveRef.current.main.list
        let oneList = saveRef.current.one.list
        let twoList = saveRef.current.two.list
        let maxLength = Math.max(mainList.length, oneList.length, twoList.length)
        for(let i = 1; i <= maxLength; i++){
           let item: IInquiryGoodsResultSaveDetail = {}
            if( mainList[i-1]?.materialCode){
                item.inquiryCode1 = saveRef.current.main.inquiryCode || ''
                item.supplierCode1 = saveRef.current.main.supplierCode || ''
                item.supplierName1 = saveRef.current.main.supplierName || ''
                item.materialCode1 = mainList[i-1]?.materialCode || ''
                item.materialName1 = mainList[i-1]?.materialName || ''
                item.price1 = mainList[i-1]?.price?.toString() || ''
            }
            if( oneList[i-1]?.materialCode){
                item.inquiryCode2 = saveRef.current.one.inquiryCode || ''
                item.supplierCode2 = saveRef.current.one.supplierCode || ''
                item.supplierName2 = saveRef.current.one.supplierName || ''
                item.materialCode2 = oneList[i-1]?.materialCode || ''
                item.materialName2 = oneList[i-1]?.materialName || ''
                item.price2 = oneList[i-1]?.price?.toString() || ''
                item.resultPrice1 = oneList[i-1]?.result?.toString() || ''
            }
            if( twoList[i-1]?.materialCode){
                item.inquiryCode3 = saveRef.current.two.inquiryCode || ''
                item.supplierCode3 = saveRef.current.two.supplierCode || ''
                item.supplierName3 = saveRef.current.two.supplierName || ''
                item.materialCode3 = twoList[i-1]?.materialCode || ''
                item.materialName3 = twoList[i-1]?.materialName || ''
                item.price3 = twoList[i-1]?.price?.toString() || ''
                item.resultPrice2 = twoList[i-1]?.result?.toString() || ''
            }
            sumInquiryDetailsResultList.push(item)
        //    sumInquiryDetailsResultList.push({
        //     inquiryCode1:  saveRef.current.main.inquiryCode || '',
        //     supplierCode1: saveRef.current.main.supplierCode || '',
        //     supplierName1: saveRef.current.main.supplierName || '',
        //     materialCode1: mainList[i-1]?.materialCode || '',
        //     materialName1: mainList[i-1]?.materialName || '',
        //     inquiryCode2:  saveRef.current.one.inquiryCode || '',
        //     supplierCode2: saveRef.current.one.supplierCode || '',
        //     supplierName2: saveRef.current.one.supplierName || '',
        //     materialCode2: oneList[i-1]?.materialCode || '',
        //     materialName2: oneList[i-1]?.materialName || '',
        //     price2: oneList[i-1]?.price || '',
        //     inquiryCode3: saveRef.current.two.inquiryCode || '',
        //     supplierCode3: saveRef.current.two.supplierCode || '',
        //     supplierName3: saveRef.current.two.supplierName || '',
        //     materialCode3: twoList[i-1]?.materialCode || '',
        //     materialName3: twoList[i-1]?.materialName || '',
        //     price3: twoList[i-1]?.price || '',
        //     resultPrice1: mainList[i-1]?.result || '',
        //     resultPrice2: oneList[i-1]?.result || '',
        //    })
        }
        params.sumInquiryDetailsResultList = sumInquiryDetailsResultList.filter(i => Object.keys(i).length > 0)
        try {
            let res = await inquiryResultService.save(params)
            if(res){
                message.success('保存成功')
            }
        } catch (err) {
            message.error(err)
        }
    }

    const changeViceInquiryList = ( type: 'one' | 'two' | 'main',k:'list' | 'supplierCode' | 'supplierName' | 'inquiryCode', info: IInquiryGoodsForContrast[] | string) => {
        if(k === 'list'){
            saveRef.current[type][k] = info as IInquiryGoodsForContrast[]
        }else{
            saveRef.current[type][k] = info as string
        }
    }
    return {
        mavbList,
        setMavbList,
        mavbChoosedSupplierCode,
        setMavbChoosedSupplierCode,
        mavbChoosedInquiryId,
        setMavbChoosedInquiryId,
        getInquiryList,
        getGoodsList,
        viceChoosedSupplierCode,
        setViceChoosedSupplierCode,
        changeMavbList,
        handelSave,
        changeViceInquiryList,
    }
})
